(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.kit-interlink').forEach(net => {
    if (net.dataset.interlinkReady) return;
    const svg = net.querySelector('svg');
    const devices = [...net.querySelectorAll('.kit-network__device')];
    if (!svg || !devices.length) return;
    net.dataset.interlinkReady = 'true';
    const lines = [...svg.querySelectorAll('path')].map((path, index) => {
      const line = path.cloneNode();
      line.classList.add('kit-signal-line');
      line.setAttribute('pathLength', '100');
      line.dataset.route = index;
      svg.appendChild(line);
      return line;
    });
    devices.forEach((device, index) => { device.dataset.route = index; });
    const count = Math.min(devices.length, lines.length);
    if (!count) return;
    const card = net.closest('.kit-feature');
    // Establish the whole network once, then rotate the initiating device.
    const opening = [['gateway', 650], ['connect', 1100], ['connected', 800], ['idle', 400]];
    const frames = [['trigger', 650], ['incoming', 1100], ['relay', 500], ['broadcast', 1100], ['all-response', 1500], ['idle', 500]];
    let timer = null, visible = false, route = 0, step = 0, openingStep = 0;
    const setPhase = phase => {
      net.dataset.phase = phase;
      if (card) card.dataset.kitPhase = phase;
    };
    const selectRoute = index => {
      net.dataset.activeRoute = index;
      devices.forEach((device, i) => device.classList.toggle('is-current', i === index));
      lines.forEach((line, i) => line.classList.toggle('is-current', i === index));
    };
    const stop = () => {
      clearTimeout(timer);
      timer = null;
      route = 0;
      step = 0;
      openingStep = 0;
      selectRoute(-1);
      setPhase('idle');
    };
    const tick = () => {
      if (!visible || document.hidden || motion.matches) { stop(); return; }
      const isOpening = openingStep < opening.length;
      selectRoute(isOpening ? -1 : route);
      const [phase, duration] = isOpening ? opening[openingStep] : frames[step];
      setPhase(phase);
      timer = setTimeout(() => {
        if (isOpening) {
          openingStep += 1;
        } else {
          step += 1;
          if (step === frames.length) {
            step = 0;
            route = (route + 1) % count;
            if (route === 0) openingStep = 0;
          }
        }
        tick();
      }, duration);
    };
    const start = () => {
      stop();
      if (visible && !document.hidden && !motion.matches) tick();
    };
    const observer = new IntersectionObserver(entries => {
      const nextVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
      if (nextVisible !== visible) { visible = nextVisible; start(); }
    }, { threshold: [0, .25] });
    observer.observe(net);
    document.addEventListener('visibilitychange', start);
    motion.addEventListener('change', start);
  });
})();
